module.exports = __webpack_public_path__ + "static/media/logo-jingold.10b87314.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-jingold.png
// module id = 741
// module chunks = 0